import PropTypes from 'prop-types';
import { useBreakpoints } from '../../../hooks/useBreakpoints';
import AdvanceTable from './AdvanceTable';
import AdvanceTableCardList from './AdvanceTableCardList';

/** 桌面表格 + 手机订单卡片，共用 AdvanceTableProvider 上下文 */
const AdvanceTableResponsive = ({
	cardBreakpoint = 'md',
	cardListClassName,
	footerCells,
	footerSpanGroups,
	getBodySpanGroups,
	getRowClassName,
	...tableProps
}) => {
	const { breakpoints } = useBreakpoints();
	const useCardLayout = breakpoints.down(cardBreakpoint);

	if (useCardLayout) {
		return (
			<AdvanceTableCardList
				className={cardListClassName}
				footerCells={footerCells}
				footerSpanGroups={footerSpanGroups}
				getBodySpanGroups={getBodySpanGroups}
				getRowClassName={getRowClassName}
			/>
		);
	}

	return (
		<AdvanceTable
			{...tableProps}
			footerCells={footerCells}
			footerSpanGroups={footerSpanGroups}
			getBodySpanGroups={getBodySpanGroups}
			getRowClassName={getRowClassName}
		/>
	);
};

AdvanceTableResponsive.propTypes = {
	cardBreakpoint: PropTypes.string,
	cardListClassName: PropTypes.string,
	footerCells: PropTypes.object,
	footerSpanGroups: PropTypes.array,
	getBodySpanGroups: PropTypes.func,
	getRowClassName: PropTypes.func,
	headerClassName: PropTypes.string,
	bodyClassName: PropTypes.string,
	rowClassName: PropTypes.string,
	tableProps: PropTypes.object,
};

export default AdvanceTableResponsive;
